import { StyleSheet } from 'aphrodite'
import { Common } from 'styles'

const styles = StyleSheet.create({
  container: {
    order: 99,
    width: Common.swiftMenuWidth,
    background: '#fff',
    borderLeft: `1px solid ${Common.borderColor}`,
    zIndex: 25
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/SwiftMenu/styles.js